import { useEffect, useState } from 'react'

export const useBlockchainVerifiedModal = () => {
  const [open, setOpen] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (open) {
      document.body.style.overflowY = 'hidden'
    } else {
      document.body.style.overflowY = 'auto'
    }
    return () => {
      document.body.style.overflowY = 'auto'
    }
  }, [open])

  const handleOpen = (initialIndex?: number) => {
    setOpen(true)
    setCurrentIndex(initialIndex ?? 0) // Use provided index or reset to the first item (0) when opening
  }

  const handleClose = () => {
    setOpen(false)
    // Reset to first item when closing
    setCurrentIndex(0)
  }

  const handlePrev = (scanLength: number) => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? scanLength - 1 : prevIndex - 1))
  }

  const handleNext = (scanLength: number) => {
    setCurrentIndex((prevIndex) => (prevIndex === scanLength - 1 ? 0 : prevIndex + 1))
  }

  return {
    open,
    setOpen,
    currentIndex,
    setCurrentIndex,
    handleOpen,
    handleClose,
    handlePrev,
    handleNext,
  }
}
